import React from "react";

const beliefs = [
  {
    iconClass: "fa-solid fa-magnifying-glass",
    title: "Discover Magical Designs",
    description: "Explore our hand-drawn colouring books filled with enchanting illustrations that spark creativity and imagination for kids and adults alike.",
  },
  {
    iconClass: "fa-solid fa-palette",
    title: "Premium Quality Pages",
    description: "Thick, bleed-proof paper perfect for crayons, markers, and pencils. Professional-grade quality that withstands creative expression.",
  },
  {
    iconClass: "fa-solid fa-indian-rupee-sign",
    title: "Budget-Friendly Creativity",
    description: "High-quality colouring books at affordable prices. Bring joy and artistic development without breaking the bank!",
  },
  {
    iconClass: "fa-solid fa-truck-fast",
    title: "Fast Delivery Across India",
    description: "Reliable shipping to your doorstep. Order today and start colouring tomorrow with our efficient delivery network.",
  },
];

function Believe() {
  return (
    <section className="row py-5 healthy">
      <div className="px-sm-5">
        <div className="text-center about-title">
          <h2 className="title text-uppercase">Creative, Affordable, Therapeutic</h2>
          <p>
          "Premium colouring books designed to ignite imagination, relieve stress, and boost focus! Our collections bring you <br /> 
          high-quality art experiences that nurture creativity for all ages—crafted with love and delivered with care."
          </p>
        </div>
      </div>

      <div className="col">
        <div className="row text-center believe">
          {beliefs.map((belief, index) => (
            <div key={index} className={`custom-card${index % 2 === 0 ? "2" : ""} col-lg-3`}>
              <div className="believeimg">
                <i className={`${belief.iconClass} fa-3x mb-3 text-primary`}></i>
              </div>
              <h5>{belief.title}</h5>
              <p>{belief.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Believe;